import { render } from "./PdfGalleryModal.vue?vue&type=template&id=4b0cf1ac&ts=true"
import script from "./PdfGalleryModal.vue?vue&type=script&lang=ts"
export * from "./PdfGalleryModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__